import styled from 'styled-components'
import colors from '../../../assets/colors'
import { tokens } from '../../../assets/tokens'

const ValuesPercentagesTable = styled.div`
  && {
    padding: 16px;
    background-color: ${colors.white};
    border-radius: 6px;
    box-shadow: 0px 4px 6px rgba(98, 102, 113, 0.06), 0px 2px 2px rgba(98, 102, 113, 0.06);
  }
  /* Título y textos con la escala de las estadísticas de talent (antes 18/700 y cifras de 24-28 px) */
  .table_header {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${tokens.color.text.primary};
  }

  .table_empty {
    margin: 0;
    padding: 24px 0;
    font-size: 13px;
    text-align: center;
    color: ${tokens.color.text.tertiary};
  }
  .values_percentages_table {
    .row_element {
      padding: 10px 12px !important;
        
      .factor_number {
        border-radius: 100%;
        display: inline-block;
        background-color: #F2F2F4;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        margin: 0 8px 0 0;
        font-size: 12px;
        font-weight: 500;
        color: #7A808D;
      }
    }
    
    .last_row_cell {
      border-bottom: 0;
    }

    .factor_name {
      background-color: transparent;
      text-align: left !important;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      color: ${tokens.color.text.primary};
      width: 45%;
    }
    
    .factor_values {
      text-align: right !important;
      display: table-cell;
      width: 55%;
      
      .factor_values__container {
        .factor_percentage{
          width: 45px;
        }
        .factor_value {
          width: 45px;
        }
        .factor_fixed{
          width: 0;        
        }
      }
      
      .big_container {
        display: flex;
        gap: 16px;
        justify-content: end;
        align-items: center;
        font-weight: 600;
        line-height: 30px;
        min-height: 100%;
        height: 100%;
        
        .big_value {
            display: inline-block;
            font-size: 16px;
        }
        .MuiLinearProgress-root {
          height: 8px;
          border-radius: 8px;
        .MuiLinearProgress-bar {
             border-radius: 8px;
          }
        }
        .big_percentage_container {
          min-width: 52px;
          width: 50%;
        }
        .big_percentage {
            display: inline-block;
            font-size: 18px;
            width: 56px;
        }
        
      }
      
      .card-container {
        background-color: unset;
        box-shadow: unset;
        min-height: unset !important;
        display: flex;
        padding: 5px 0;
        
        .value-stat {
        }
      }
      
      &__container {
        display: flex;
        gap: 24px;
        justify-content: end;
        align-items: center;
        font-weight: 600;
        font-size: 14px;
        line-height: 30px;
        min-height: 100%;
        height: 100%;
      }
      
      div .percentage_container {
        min-width: 52px;
        width: 30%;
      }
    }
  }

`

export default ValuesPercentagesTable
